import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addReportReason,
  deleteReportReason,
  getReportReason,
  updateReportReason,
} from "store/services/dataManagement/reportReason";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Report Reason
export const GetAllReportReasonAction = createAsyncThunk(
  "reportReason/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getReportReason(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete Report Reason
export const DeleteReportReasonAction = createAsyncThunk(
  "reportReason/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteReportReason(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getReportReason(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update Report Reason
export const UpdateReportReasonAction = createAsyncThunk(
  "reportReason/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSucess, onError } = payload;
      const res = await updateReportReason(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add Report Reason
export const AddReportReasonAction = createAsyncThunk(
  "reportReason/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSucess, onError, filter, ...rest } = payload;
      const res = await addReportReason(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        const responce = await getReportReason(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
